import React, { useState, useEffect } from "react";
import DateComponent from "../../../components/datepicker";
import Api from "../../../services/api";
import moment from "moment/moment";
import {toast} from "react-toastify";
import LoadingComponent from "../../../components/loading";
import { END_DATE, START_DATE } from "../../../utility";

function Revenue() {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);

    const [startDate,setStartDate] = useState(moment().subtract(START_DATE, 'days'));
    const [endDate,setEndDate] = useState(moment().subtract(END_DATE, 'days'));

    const [refresh, setRefresh] = useState(false);

    const handleChangeDate = (event, picker) => {
        setStartDate(picker.startDate)
        setEndDate(picker.endDate)
    };

    useEffect(() => {
        setLoading(true);
        Api.get(`/api/revenue_reconciliation?from=${startDate.format('YYYY-MM-DD')}&to=${ endDate.format('YYYY-MM-DD')}`)
            .then(result => {
                if(result.data.code == 0) {
                    setData(result.data.data);
                }else {
                    toast.error("Lỗi lấy dữ liệu !!");
                }
                setLoading(false)
            });
    }, [startDate,endDate]);


    // Tính tổng doanh thu
    const totalRevenue = data.reduce((acc, item) => acc + (item.proceeds || 0), 0);

    return (
        <>
            <section className="main__filter">
                <div className="filter">
                    <div className="container-fluid">
                        <form action="" method="get" id="form">
                            <div className="row d-flex flex-row-reverse">

                                <div className="col-md-3 d-flex justify-content-end">
                                    <div className="form-group" style={{marginBottom: "0"}}>
                                        <div className="filter-sticky">
                                            <div className="d-flex justify-content-end">
                                                <DateComponent startDate={startDate}
                                                               endDate={endDate}
                                                               handleChangeDate={handleChangeDate}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <button type="button" className="btn btn-outline-warning" style={{ marginLeft: '25px' }}>Export</button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </section>
            <section className="main__content">
                <div className="container-fluid">
                    <div className="mb-4">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="title-head-box">
                                    <p className="title-block">Revenue reconciliation</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="mb-4">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="box box--chart mb-4">
                                    <div className="box__header">
                                        <div className="d-flex align-items-center justify-content-between">
                                            <p className="title-box-report">Revenue</p>
                                        </div>
                                    </div>
                                    <div className="box__content custom-table">
                                        <LoadingComponent loading={loading} />
                                        <div className="table-responsive">
                                            <table className="table m-0 table--text-bold">
                                                <thead>
                                                <tr className="border-bt">
                                                    <th scope="col">Country or Region(Currency)</th>
                                                    <th scope="col" className="text-center">Units Sold</th>
                                                    <th scope="col" className="text-center">Earned</th>
                                                    <th scope="col" className="text-center">Input Tax</th>
                                                    <th scope="col" className="text-center">Adjustments</th>
                                                    <th scope="col" className="text-center">Withholding Tax</th>
                                                    <th scope="col" className="text-center">Total Owed</th>
                                                    <th scope="col" className="text-center">Proceeds</th>
                                                    <th scope="col" className="text-center">Bank Account Currency</th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                {data.length > 0 ? (
                                                    data.map((item, index) => (
                                                    <tr key={index}>
                                                        <td>{item.country}</td>
                                                        <td className="text-center">{item.units_sold.toLocaleString()}</td>
                                                        <td className="text-center">{item.earned.toLocaleString()}</td>
                                                        <td className="text-center">{item.input_tax.toLocaleString()}</td>
                                                        <td className="text-center">{item.adjustments.toLocaleString()}</td>
                                                        <td className="text-center">{item.withholding_tax.toLocaleString()}</td>
                                                        <td className="text-center">{item.total_owed.toLocaleString()}</td>
                                                        <td className="text-center">{item.proceeds.toLocaleString()}</td>
                                                        <td className="text-center">{item.currency}</td>
                                                    </tr>
                                                ))) : (
                                                    <tr>
                                                        <td colSpan="9" className="border border-gray-300 px-4 py-2 text-center">
                                                            No data available
                                                        </td>
                                                    </tr>
                                                )}
                                                </tbody>
                                            </table>
                                        </div>
                                        <div className="row justify-content-end mt-3">
                                            <div className="col-md-4">
                                                <table className="table m-0 table--text-bold table-bordered">
                                                    <tbody>
                                                    <tr className="border-bt">
                                                        <td className="text-center font-weight-bold">{totalRevenue.toLocaleString()}</td>
                                                        <td className="text-center font-weight-bold">USD</td>
                                                    </tr>
                                                    <tr className="border-bt">
                                                        <td colSpan={2} className="text-center font-weight-bold">
                                                            Estimated Proceeds
                                                        </td>
                                                    </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}

export default Revenue;
